module.exports = __webpack_public_path__ + "img/83.1.00d34b33.jpg";